import React from "react";
import { object, number } from "prop-types";

import { toBanglaNum } from "../../utils/utils";

import "./pollProgress.m.css";

export default function PollProgress({ item, totalVotes }) {
  return (
    <div styleName="voteArea">
      <div styleName="progressBar" style={{ width: item?.["percentage-votes"] + "%" }}></div>
      <div styleName="poll-text">
        {`${item?.text} (${toBanglaNum(Math.round((item?.["percentage-votes"] / 100) * totalVotes))} জন)`}
      </div>
      <div styleName="poll-parcentage">{toBanglaNum(item?.["percentage-votes"]) + "%"}</div>
    </div>
  );
}

PollProgress.propTypes = {
  item: object,
  totalVotes: number,
};
